export const candidaturaTourSteps = [
  {
    selector: '[data-tour="candidatura-intro"]',
    content: 'Benvenuto! In 4 step compili la candidatura. Puoi salvare una bozza in qualsiasi momento e ricevere un codice via email.',
    position: 'bottom',
  },
  {
    selector: '[data-tour="candidatura-stepper"]',
    content: 'La barra mostra dove sei nel percorso: Chi sei → Prodotti → Documenti → Invio. La percentuale indica quanto hai completato.',
    position: 'bottom',
  },
  {
    selector: '[data-tour="candidatura-categoria"]',
    content: 'Step 1 — Scegli la categoria principale. Non è vincolante: potrai aggiungere prodotti di tipologie diverse negli step successivi.',
    position: 'bottom',
  },
  {
    selector: '[data-tour="candidatura-bozza"]',
    content: 'Inserisci ragione sociale e almeno un referente con email. Con questi dati puoi già salvare la bozza e ottenere il codice accesso.',
    position: 'top',
  },
  {
    selector: '[data-tour="candidatura-prodotti"]',
    content: 'Step 2 — Descrivi i prodotti che vuoi proporre: nome, capacità produttiva, costi e tipo spedizione. Salta se hai scelto Logistica.',
    position: 'top',
  },
  {
    selector: '[data-tour="candidatura-documenti"]',
    content: 'Step 3 — Documenti e messaggio sono facoltativi. Cataloghi e schede tecniche aiutano il team a valutarti più rapidamente.',
    position: 'top',
  },
  {
    selector: '[data-tour="candidatura-invio"]',
    content: 'Step 4 — Controlla il riepilogo. Salva Bozza = codice via email, nessuna valutazione. Invia Candidatura = il team inizia la revisione.',
    position: 'top',
  },
  {
    selector: '[data-tour="candidatura-nav"]',
    content: 'Usa Indietro e Avanti per muoverti tra gli step. Il pulsante "Hai già il codice?" in alto recupera una candidatura salvata.',
    position: 'top',
  },
];
